import Vue from 'vue';

export default {
  state: {
    careerPage: {},
    vacanciesList: [],
  },
  mutations: {
    setCareerPage(state, data) {
      state.careerPage = data;
    },
    setVacanciesList(state, data) {
      state.vacanciesList = data;
    },
  },
  actions: {
    getCareerPage(store) {
      const path = 'career';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setCareerPage', resp.data);
        return resp.data;
      });
    },
    getVacanciesList(store) {
      const path = 'vacancies';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setVacanciesList', resp.data);
        return resp.data;
      });
    },
    sendSummary(store, file) {
      const path = 'summaries';
      const Fdata = new FormData();
      Fdata.append('files', file);
      return Vue.prototype.$axios.post('upload', Fdata).then((resp) => {
        Fdata.append('document', JSON.stringify(resp.data[0]));
        return Vue.prototype.$axios.post(path, Fdata);
      });
    },
  },
};
